import type { ReactNode } from 'react'
import { Button } from '@/components/Button'
import styles from './SymbolConnectorList.module.css'

export interface SymbolConnectorListProps {
  /**
   * The connectors.
   */
  children?: ReactNode
  /**
   * Shows an "Add" button in place of the connectors.
   */
  isEmpty: boolean
  onAdd: () => unknown
  isDisabled?: boolean
  testId?: string
}

/**
 * Stacks the connectors of a list, like a mutator's targets.
 */
export function SymbolConnectorList({
  children,
  isEmpty,
  onAdd,
  isDisabled,
  testId,
}: SymbolConnectorListProps) {
  return (
    <div className={styles.root} data-test={testId}>
      {children}
      {isEmpty && (
        <div>
          <Button
            label="Add"
            variant="primary"
            size="small"
            flat
            iconLeft="add"
            isDisabled={isDisabled}
            onPress={onAdd}
            testId={testId && `${testId}-add-button`}
          />
        </div>
      )}
    </div>
  )
}
